import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const FilterPanel = ({ onFilterChange, onRateConfig }) => {
  const [filters, setFilters] = useState({
    period: 'monthly',
    year: '2024',
    quarter: 'Q4',
    status: 'all',
  });

  const periodOptions = [
    { value: 'monthly', label: 'Monthly View' },
    { value: 'quarterly', label: 'Quarterly View' },
    { value: 'yearly', label: 'Yearly View' },
  ];

  const yearOptions = [
    { value: '2024', label: '2024' },
    { value: '2023', label: '2023' },
    { value: '2022', label: '2022' },
  ];

  const quarterOptions = [
    { value: 'Q1', label: 'Q1 (Jan-Mar)' },
    { value: 'Q2', label: 'Q2 (Apr-Jun)' },
    { value: 'Q3', label: 'Q3 (Jul-Sep)' },
    { value: 'Q4', label: 'Q4 (Oct-Dec)' },
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'draft', label: 'Draft' },
    { value: 'pending', label: 'Pending' },
    { value: 'paid', label: 'Paid' },
    { value: 'overdue', label: 'Overdue' },
  ];

  const handleFilterChange = (field, value) => {
    const newFilters = {
      ...filters,
      [field]: value,
    };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handleReset = () => {
    const defaultFilters = {
      period: 'monthly',
      year: '2024',
      quarter: 'Q4',
      status: 'all',
    };
    setFilters(defaultFilters);
    onFilterChange(defaultFilters);
  };

  return (
    <div className="bg-white rounded-lg border border-slate-200 p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} color="#3B82F6" />
          <h3 className="text-lg font-semibold text-slate-900">Filters</h3>
        </div>
        <Button variant="ghost" size="sm" onClick={handleReset}>
          Reset
        </Button>
      </div>
      <div className="space-y-4">
        <Select
          label="View Period"
          options={periodOptions}
          value={filters?.period}
          onChange={(value) => handleFilterChange('period', value)}
        />

        <Select
          label="Year"
          options={yearOptions}
          value={filters?.year}
          onChange={(value) => handleFilterChange('year', value)}
        />

        {filters?.period === 'quarterly' && (
          <Select
            label="Quarter"
            options={quarterOptions}
            value={filters?.quarter}
            onChange={(value) => handleFilterChange('quarter', value)}
          />
        )}

        <Select
          label="Payment Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => handleFilterChange('status', value)}
        />
      </div>
      <div className="pt-4 border-t border-slate-200">
        <Button
          variant="default"
          fullWidth
          iconName="Settings"
          onClick={onRateConfig}
        >
          Fee Rate Config
        </Button>
      </div>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="#3B82F6" />
          <div>
            <p className="text-sm font-medium text-blue-900 mb-1">
              Quick Actions
            </p>
            <div className="space-y-2 mt-2">
              <button className="w-full text-left text-sm text-blue-700 hover:text-blue-900 flex items-center gap-2">
                <Icon name="Download" size={16} />
                Export All Records
              </button>
              <button className="w-full text-left text-sm text-blue-700 hover:text-blue-900 flex items-center gap-2">
                <Icon name="FileText" size={16} />
                Generate Report
              </button>
              <button className="w-full text-left text-sm text-blue-700 hover:text-blue-900 flex items-center gap-2">
                <Icon name="Send" size={16} />
                Bulk Invoice Send
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-slate-50 rounded-lg p-4">
        <h4 className="text-sm font-semibold text-slate-900 mb-3">
          Payment Status Summary
        </h4>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-green-500" />
              <span className="text-sm text-slate-700">Paid</span>
            </div>
            <span className="text-sm font-semibold text-slate-900">8</span>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-yellow-500" />
              <span className="text-sm text-slate-700">Pending</span>
            </div>
            <span className="text-sm font-semibold text-slate-900">3</span>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-red-500" />
              <span className="text-sm text-slate-700">Overdue</span>
            </div>
            <span className="text-sm font-semibold text-slate-900">1</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;